import {
  getAuthorizedBitrixUserId,
  refreshBitrixUserHistory,
} from '@context/useBitrixUser/useBitrix';
import { getVariantServicesToCalculate } from '@pages/AdditionalServices/containers/methods/getVariantServicesToCalculate';
import { AdditionServicesState } from '@pages/AdditionalServices/containers/types';
import { servicesServicesService } from '@services/requests/servicesService/servicesServicesService';

let lastSentShortLink: string | null = null;

/**
 * Повторный расчет выбранного варианта с короткой ссылкой — так бэкенд запишет его в историю.
 * Результат расчета не используется.
 */
export const sendServicesHistory = async (
  shortLink: string | null | undefined,
  serviceState: AdditionServicesState
) => {
  if (!shortLink || shortLink === lastSentShortLink || !serviceState.SelectedVariant) {
    return;
  }

  lastSentShortLink = shortLink;

  try {
    const services = getVariantServicesToCalculate(serviceState, serviceState.SelectedVariant);
    const bitrixUserId = await getAuthorizedBitrixUserId();

    const result = await servicesServicesService().ServicePriceCalculationForHistory(services, {
      shortLink,
      bitrixUserId,
    });

    if (result && bitrixUserId !== undefined) {
      refreshBitrixUserHistory();
    }
  } catch (error) {
    console.error(error?.message);

    if (lastSentShortLink === shortLink) {
      lastSentShortLink = null;
    }
  }
};
